import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { selectUser } from '../../authentication/redux/selectors';
import { useVariantStep } from '../hooks/use_variant_step';
import { useHasRunningRefresh } from '../hooks/useHasRunningRefresh';
import { useVariantAccess } from '../hooks/useVariantAccess';
import { PubMedPublication } from '../redux';
import PubMedModal from './PubMedModal';
import ReferenceModal from './ReferenceModal';

type AddReferenceProps = {
  stageType?: string;
};

const AddReference = ({ stageType: propStageType }: AddReferenceProps) => {
  const user = useSelector(selectUser);
  const { canEditWorkflow } = useVariantAccess();
  const hasRunningRefresh = useHasRunningRefresh();
  // derive current stage from route and resolve stage info
  const { stageType: urlStageType } = useParams();
  const stageInfo = useVariantStep(urlStageType || propStageType);

  const [isReferenceModalOpen, setIsReferenceModalOpen] = useState(false);
  const [isPubMedModalOpen, setIsPubMedModalOpen] = useState(false);
  const [pubmedPublication, setPubMedPublication] =
    useState<PubMedPublication | null>(null);

  const handleAddReferenceClick = () => {
    setIsPubMedModalOpen(true);
  };

  const handleReferenceModalClose = () => {
    setIsReferenceModalOpen(false);
  };

  const handlePubMedModalClose = () => {
    setIsPubMedModalOpen(false);
  };

  const onPubMedSuccess = (pubmedPublication: PubMedPublication) => {
    setPubMedPublication(pubmedPublication);
    setIsReferenceModalOpen(true);
  };

  // disable logic for add reference button
  const isReferenceDisabled =
    !user?.id ||
    !canEditWorkflow ||
    hasRunningRefresh ||
    (stageInfo?.status !== 'revised' && stageInfo?.status !== 'not_started');

  return (
    <>
      {isReferenceModalOpen && pubmedPublication && (
        <ReferenceModal
          closeModal={handleReferenceModalClose}
          type="add"
          pubmedPublication={pubmedPublication}
          stageType={propStageType || urlStageType}
        />
      )}

      {isPubMedModalOpen && (
        <PubMedModal
          closeModal={handlePubMedModalClose}
          onPubMedSuccess={onPubMedSuccess}
        />
      )}

      <Button
        className="clinical-obs__variant-databases-add-btn"
        type="primary"
        onClick={handleAddReferenceClick}
        icon={<FontAwesomeIcon icon={faPlus} />}
        disabled={isReferenceDisabled}
      >
        Reference
      </Button>
    </>
  );
};

export default AddReference;
